import { Link } from 'react-router-dom';
import SvgIcon from '../../SvgIcon/SvgIcon';

interface Props {
  triggerRef: React.RefObject<HTMLAnchorElement>;
  unreadCount: number;
  onClick: () => void;
}

const NotificationIconButton: React.FC<Props> = ({
  triggerRef,
  unreadCount,
  onClick,
}) => (
  <Link
    ref={triggerRef}
    onClick={onClick}
    to="#"
    className="relative flex h-9 w-9 items-center justify-center rounded-full border border-stroke bg-gray hover:text-primary dark:border-strokedark dark:bg-meta-4 dark:text-white transition-colors duration-200"
  >
    {/* 🔢 Badge numérico animado */}
    {unreadCount > 0 && (
      <span className="absolute -top-2.5 -right-2.5 flex items-center justify-center">
        <span className="relative flex h-4.5 min-w-[18px] items-center justify-center rounded-full bg-meta-1 px-1.5 text-[10px] font-bold text-white shadow-md">
          {unreadCount}
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-meta-1 opacity-60"></span>
        </span>
      </span>
    )}

    <SvgIcon
      name="notification"
      width={18}
      height={18}
      className="text-gray-700 dark:text-gray-200 transition duration-300"
    />
  </Link>
);

export default NotificationIconButton;
